// extracted by mini-css-extract-plugin
export var bandeauAlertContainer = "bandeau-alert-module--bandeau-alert-container--c2fb1";
export var bandeauAlertTitle = "bandeau-alert-module--bandeau-alert-title--be9ff";
export var editButton = "bandeau-alert-module--edit-button--53ba5";
export var sectionAlert = "bandeau-alert-module--section-alert--933c3";
export var sectionAlertButton = "bandeau-alert-module--section-alert-button--f779d";
export var sectionAlertContent = "bandeau-alert-module--section-alert-content--d504f";
export var sectionAlertHeader = "bandeau-alert-module--section-alert-header--5c3b0";
export var sectionAlertModal = "bandeau-alert-module--section-alert-modal--9db34";
export var sectionAlertTitle = "bandeau-alert-module--section-alert-title--906df";